const {atom} = require('jotai');

const permChangeAtom = atom(false);

export {permChangeAtom};
